import { useMemo } from "react";
import type { AlarmOverride } from "@src/services/api/types";

export type OverrideMode = "override" | "adjust";

interface ArmStateLike {
  isInOverride?: boolean;
  activeOverride?: AlarmOverride | null;
}

interface UseAlarmOverridePanelStateOptions {
  mode: OverrideMode;
  isArmed: boolean;
  armedState?: ArmStateLike | null;
}

export function useAlarmOverridePanelState({ mode, isArmed, armedState }: UseAlarmOverridePanelStateOptions) {
  const activeOverride = useMemo(() => {
    if (mode !== "adjust") return null;
    if (!armedState?.isInOverride) return null;
    return armedState.activeOverride ?? null;
  }, [mode, armedState]);

  const targetAction = useMemo<"armed" | "disarmed">(() => {
    if (mode === "adjust") {
      if (activeOverride) {
        return activeOverride.action;
      }
      return isArmed ? "armed" : "disarmed";
    }
    return isArmed ? "disarmed" : "armed";
  }, [mode, activeOverride, isArmed]);

  return { activeOverride, targetAction };
}
